import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { CreateIssueTypeViewTopBar } from "./TopBar"

export const createIssueTypeViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: CreateIssueTypeViewTopBar,
}
